import React from 'react';
import PropTypes from 'prop-types';
import ChevronRight from '@elliemae/ds-icons/ChevronRight';
import { DSIconColors, DSIconSizes } from '@elliemae/ds-basic/Icon';
import { i as iconColors, a as iconSizes } from '../../prop-types-8c5debac.js';

var Navigation = function Navigation(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? 'date-picker-navigation' : _ref$className,
      _ref$icon = _ref.icon,
      Icon = _ref$icon === void 0 ? ChevronRight : _ref$icon,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? DSIconColors.NEUTRAL : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? DSIconSizes.S : _ref$size,
      innerRef = _ref.innerRef;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Icon, {
    className: className,
    color: color,
    innerRef: innerRef,
    size: size
  }));
};

Navigation.propTypes = {
  className: 'date-picker-navigation',
  icon: PropTypes.element,
  color: PropTypes.oneOf(iconColors),
  size: PropTypes.oneOf(iconSizes),
  innerRef: PropTypes.any
};

export default Navigation;
//# sourceMappingURL=DatePickerNavigation.js.map
